
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30195',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30195",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54401",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7972",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11417",
  "I18n": "static-7.1611",
  "quartz": "static-1.6962",
  "quartz-config": "static-1.740",
  "quartz-core": "static-1.6181",
  "react-dlb": "static-1.78",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.779",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54388",
  "feedback-utils": "static-1.54392",
  "forms-embed-utils-lib": "static-1.4417",
  "forms-utils-lib": "static-1.12488",
  "foundations-assets": "static-1.4812",
  "foundations-components": "static-1.7841",
  "foundations-theming": "static-1.4372",
  "hub-http": "static-1.6177",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11725",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3880",
  "raven": "static-3.5829",
  "react": "static-7.185",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1-feature-id-1324-marker-timings.12",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5307",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.486",
  "tinymce-plugins": "static-1.57338",
  "transmute": "static-2.85",
  "ui-images": "static-2.1140",
  "UIComponents": "static-3.8364",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3367",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3239",
  "quartz-webpack": "static-1.3186",
  "foundations-theming-specialty": "static-1.2088",
  "property-description-translator": "static-1.3802",
  "HeadJS": "static-2.741",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3083",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4280",
  "jasmine-runner": "static-1.6425",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.827",
  "hubspotter-http": "static-1.4615",
  "mobile-manifest-mixins": "static-1.515",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.637",
  "quartz-head": "static-1.627",
  "quartz-i18n": "static-1.637",
  "quartz-routing": "static-1.392",
  "quartz-test": "static-1.637",
  "quartz-tracking": "static-1.341",
  "ui-fonts": "static-1.679",
  "usage-tracker-container": "static-1.7284",
  "usage-tracker-core": "static-1.7144",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7204",
  "reference-resolvers": "static-1.8126",
  "sanitize-text": "static-1.8099",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10327",
  "sanitize": "static-1.4428",
  "outpost": "static-1.4144",
  "rpc-client-utils": "static-1.4606",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4110",
  "floating-ui": "static-1.55",
  "hs-story-utils": "static-1.9384",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.10",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1700",
  "bend-plugin-foundations-theming": "static-1.2855",
  "foundations-theming-base": "static-1.3357",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.47",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "ai-components-ui-library": "static-1.8808",
  "atom": "static-1.5028",
  "codemirror": "static-5.94",
  "content-assistance-lib": "static-1.7679",
  "ContentUtils": "static-1.68216",
  "data-token-picker": "static-1.16320",
  "file-manager-components": "static-1.23481",
  "FileManagerCore": "static-1.38980",
  "FileManagerLib": "static-1.39121",
  "frontend-preferences-client": "static-1.7883",
  "hub-http-contrib": "static-1.2996",
  "interframe": "static-3.4717",
  "layout-dnd-components": "static-1.12352",
  "layout-dnd-utils": "static-1.11327",
  "property-translator": "static-1.5357",
  "react-codemirror": "static-1.10579",
  "react-colorpicker": "static-2.10166",
  "reference-resolvers-lite": "static-1.8050",
  "rich-text-lib": "static-1.19748",
  "tinymce-data": "static-1.40309",
  "tinymce-themes": "static-1.56194",
  "ui-addon-emoji-picker": "static-1.9843",
  "ui-addon-sales-email": "static-1.5166",
  "ui-brand-identity-lib": "static-1.15027",
  "bender-build-tools": "static-1.3123",
  "hub-http-shared-msw-handlers": "static-1.9849",
  "hubspotter-http-shared-msw-handlers": "static-1.9847",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4980",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.16",
  "chirp-fetch": "static-1.1841",
  "chatspot-core": "static-1.21051",
  "copilot-toolkit": "static-1.10986",
  "customer-data-objects-ui-components": "static-1.12981",
  "data-fetching-client": "static-1.9630",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4722",
  "ui-addon-video-player": "static-1.8654",
  "ui-coaching-tips": "static-1.28404",
  "usage-tracker": "static-1.7294",
  "cms-field-types": "static-1.4767",
  "content-icons-ui": "static-1.2213",
  "integrations-lib": "static-1.15958",
  "customer-data-objects": "static-1.7618",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4604",
  "apollo-stack-hubspot": "static-3.85",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "immerable": "static-1.4109",
  "ui-addon-iframeable": "static-1.9011",
  "video-components-external": "static-1.11104",
  "video-data-lib": "static-1.34762",
  "audio-components": "static-1.5844",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29210",
  "FileManagerImages": "static-1.36632",
  "foundations-components-legacy": "static-1.866",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.524",
  "ui-universal-auth": "static-1.8918",
  "urlinator": "static-1.4487",
  "video-components": "static-1.13107",
  "video-embed": "static-1.35596",
  "ts-schema": "static-1.4041",
  "ContentData": "static-1.68291",
  "layout-data-lib": "static-1.9652",
  "react-dnd-compat": "static-1.4576",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1506",
  "external-options-client-types": "static-1.4122",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6834",
  "hs-promise-utils": "static-1.5549",
  "inbound-db-properties-service-client": "static-1.3804",
  "NamespacedHubStyle": "static-2.9026",
  "growth-onboarding-confetti": "static-1.3023",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11106",
  "amplitude-session-replay-browser": "static-1.59",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5531",
  "magpie-types": "static-1.4991",
  "simple-logging-lib": "static-1.3005",
  "avatar-components": "static-1.2454",
  "customer-data-ui-utilities": "static-1.9782",
  "growth-onboarding-feedback-components": "static-1.6539",
  "flux-actions": "static-1.331",
  "hubspot-apollo-client": "static-1.4832",
  "integrations-error-boundary-lib": "static-1.13373",
  "integrations-tracking-lib": "static-1.5554",
  "laboratory-lib": "static-3.7114",
  "native-integrations-shared-strings": "static-1.7739",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10104",
  "unified-auth": "static-1.432",
  "navigation-messaging": "static-1.7193",
  "content-media-composition-data-lib": "static-1.12081",
  "content-media-compositions": "static-2.16088",
  "idb-keyval": "static-1.43",
  "media-bridge-lib": "static-1.18844",
  "unified-auth-core-lib": "static-1.713",
  "social-insights-client-types": "static-1.21948",
  "advanced-menus-core": "static-1.15052",
  "advanced-menus-lib": "static-1.12003",
  "ExportDialog": "static-6.10349",
  "ui-memberships-settings-lib": "static-1.33909",
  "conditional-properties-service-client": "static-1.3760",
  "crm-pipelines-api-client-types": "static-1.4106",
  "framework-builder-read-service-client": "static-1.3973",
  "framework-data-schema-quick-fetch": "static-1.6739",
  "inbound-db-meta-service-client": "static-1.3554",
  "multi-currency-client-types": "static-1.3655",
  "persist-promise": "static-1.3663",
  "foundations-components-test-utils": "static-1.5324",
  "reactive-lib": "static-1.677",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.291",
  "universal-page-editor-lib": "static-1.2968",
  "google-sheets-integration-lib": "static-1.89",
  "microsoft-drive-integration-lib": "static-1.201",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3688",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15051",
  "simple-menus-lib": "static-1.16568",
  "crm-record-cards-service-types": "static-1.3572",
  "location-customization-utils-lib": "static-1.9095",
  "react-flip-move": "static-1.69"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30195",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54401",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7972",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11417",
  "I18n": "/I18n/static-7.1611",
  "quartz": "/quartz/static-1.6962",
  "quartz-config": "/quartz-config/static-1.740",
  "quartz-core": "/quartz-core/static-1.6181",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.779",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54388",
  "feedback-utils": "/feedback-utils/static-1.54392",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4417",
  "forms-utils-lib": "/forms-utils-lib/static-1.12488",
  "foundations-assets": "/foundations-assets/static-1.4812",
  "foundations-components": "/foundations-components/static-1.7841",
  "foundations-theming": "/foundations-theming/static-1.4372",
  "hub-http": "/hub-http/static-1.6177",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11725",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3880",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.185",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1324-marker-timings.12",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5307",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tinymce-plugins": "/tinymce-plugins/static-1.57338",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1140",
  "UIComponents": "/UIComponents/static-3.8364",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3367",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3239",
  "quartz-webpack": "/quartz-webpack/static-1.3186",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2088",
  "property-description-translator": "/property-description-translator/static-1.3802",
  "HeadJS": "/HeadJS/static-2.741",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3083",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4280",
  "jasmine-runner": "/jasmine-runner/static-1.6425",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.827",
  "hubspotter-http": "/hubspotter-http/static-1.4615",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.637",
  "quartz-head": "/quartz-head/static-1.627",
  "quartz-i18n": "/quartz-i18n/static-1.637",
  "quartz-routing": "/quartz-routing/static-1.392",
  "quartz-test": "/quartz-test/static-1.637",
  "quartz-tracking": "/quartz-tracking/static-1.341",
  "ui-fonts": "/ui-fonts/static-1.679",
  "usage-tracker-container": "/usage-tracker-container/static-1.7284",
  "usage-tracker-core": "/usage-tracker-core/static-1.7144",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7204",
  "reference-resolvers": "/reference-resolvers/static-1.8126",
  "sanitize-text": "/sanitize-text/static-1.8099",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10327",
  "sanitize": "/sanitize/static-1.4428",
  "outpost": "/outpost/static-1.4144",
  "rpc-client-utils": "/rpc-client-utils/static-1.4606",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4110",
  "floating-ui": "/floating-ui/static-1.55",
  "hs-story-utils": "/hs-story-utils/static-1.9384",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.10",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1700",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2855",
  "foundations-theming-base": "/foundations-theming-base/static-1.3357",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.47",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8808",
  "atom": "/atom/static-1.5028",
  "codemirror": "/codemirror/static-5.94",
  "content-assistance-lib": "/content-assistance-lib/static-1.7679",
  "ContentUtils": "/ContentUtils/static-1.68216",
  "data-token-picker": "/data-token-picker/static-1.16320",
  "file-manager-components": "/file-manager-components/static-1.23481",
  "FileManagerCore": "/FileManagerCore/static-1.38980",
  "FileManagerLib": "/FileManagerLib/static-1.39121",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7883",
  "hub-http-contrib": "/hub-http-contrib/static-1.2996",
  "interframe": "/interframe/static-3.4717",
  "layout-dnd-components": "/layout-dnd-components/static-1.12352",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11327",
  "property-translator": "/property-translator/static-1.5357",
  "react-codemirror": "/react-codemirror/static-1.10579",
  "react-colorpicker": "/react-colorpicker/static-2.10166",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8050",
  "rich-text-lib": "/rich-text-lib/static-1.19748",
  "tinymce-data": "/tinymce-data/static-1.40309",
  "tinymce-themes": "/tinymce-themes/static-1.56194",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9843",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5166",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15027",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9849",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9847",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4980",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.16",
  "chirp-fetch": "/chirp-fetch/static-1.1841",
  "chatspot-core": "/chatspot-core/static-1.21051",
  "copilot-toolkit": "/copilot-toolkit/static-1.10986",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12981",
  "data-fetching-client": "/data-fetching-client/static-1.9630",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4722",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8654",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28404",
  "usage-tracker": "/usage-tracker/static-1.7294",
  "cms-field-types": "/cms-field-types/static-1.4767",
  "content-icons-ui": "/content-icons-ui/static-1.2213",
  "integrations-lib": "/integrations-lib/static-1.15958",
  "customer-data-objects": "/customer-data-objects/static-1.7618",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4604",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4109",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9011",
  "video-components-external": "/video-components-external/static-1.11104",
  "video-data-lib": "/video-data-lib/static-1.34762",
  "audio-components": "/audio-components/static-1.5844",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29210",
  "FileManagerImages": "/FileManagerImages/static-1.36632",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.866",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.524",
  "ui-universal-auth": "/ui-universal-auth/static-1.8918",
  "urlinator": "/urlinator/static-1.4487",
  "video-components": "/video-components/static-1.13107",
  "video-embed": "/video-embed/static-1.35596",
  "ts-schema": "/ts-schema/static-1.4041",
  "ContentData": "/ContentData/static-1.68291",
  "layout-data-lib": "/layout-data-lib/static-1.9652",
  "react-dnd-compat": "/react-dnd-compat/static-1.4576",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1506",
  "external-options-client-types": "/external-options-client-types/static-1.4122",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6834",
  "hs-promise-utils": "/hs-promise-utils/static-1.5549",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3804",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9026",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3023",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11106",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5531",
  "magpie-types": "/magpie-types/static-1.4991",
  "simple-logging-lib": "/simple-logging-lib/static-1.3005",
  "avatar-components": "/avatar-components/static-1.2454",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9782",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6539",
  "flux-actions": "/flux-actions/static-1.331",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4832",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13373",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5554",
  "laboratory-lib": "/laboratory-lib/static-3.7114",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7739",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10104",
  "unified-auth": "/unified-auth/static-1.432",
  "navigation-messaging": "/navigation-messaging/static-1.7193",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12081",
  "content-media-compositions": "/content-media-compositions/static-2.16088",
  "idb-keyval": "/idb-keyval/static-1.43",
  "media-bridge-lib": "/media-bridge-lib/static-1.18844",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.713",
  "social-insights-client-types": "/social-insights-client-types/static-1.21948",
  "advanced-menus-core": "/advanced-menus-core/static-1.15052",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12003",
  "ExportDialog": "/ExportDialog/static-6.10349",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33909",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3760",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4106",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3973",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6739",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3554",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3655",
  "persist-promise": "/persist-promise/static-1.3663",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5324",
  "reactive-lib": "/reactive-lib/static-1.677",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.291",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2968",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.89",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.201",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3688",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15051",
  "simple-menus-lib": "/simple-menus-lib/static-1.16568",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3572",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9095",
  "react-flip-move": "/react-flip-move/static-1.69"
}
};
